import { style } from '@vanilla-extract/css';

export const listContainer = style({
  paddingTop: 'var(--wt-list-padding-top)',
  paddingBottom: 'var(--wt-list-padding-bottom)',
  paddingLeft: 'calc(var(--wt-padding) + var(--wt-list-padding-left))',
  paddingRight: 'calc(var(--wt-padding) + var(--wt-list-padding-right))',
});
